// ─── ЗЕРКАЛО server/config/constants.js ─────────────────────────────────────
// При добавлении новых значений — редактировать ТОЛЬКО server/config/constants.js,
// затем синхронизировать сюда. В идеале — генерировать этот файл скриптом.
//
// TODO: npm run sync-constants → node scripts/sync-constants.js
// (копирует из server/config/constants.js, убирает module.exports, добавляет export)

export const ROLES = {
  OWNER:           'owner',
  DIRECTOR:        'director',
  FINANCIER:       'financier',
  BOOKING_MANAGER: 'booking_manager',
  HOTEL_ADMIN:     'hotel_admin',
  MARKETING:       'marketing',
  INVESTOR:        'investor',
};

export const ROLE_LABELS = {
  owner:           'Собственник',
  director:        'Руководитель',
  financier:       'Финансист',
  booking_manager: 'Менеджер отдела бронирования',
  hotel_admin:     'Администратор отеля',
  marketing:       'Маркетинг',
  investor:        'Инвестор',
};

export const ROLE_NAV = {
  owner:           ['dashboard','crm','advertising','bookings','reviews','transactions','bank_import','reports','payroll','breakfasts','settings','users','audit_log'],
  director:        ['dashboard','crm','advertising','bookings','reviews','transactions','bank_import','reports','payroll','breakfasts','settings','audit_log'],
  financier:       ['dashboard','advertising','bookings','reviews','transactions','bank_import','reports','payroll','breakfasts'],
  // payroll — только вкладка KPI своего сотрудника (Payroll.jsx скрывает
  // «Смены»/«Ведомость» для этих ролей: там ставки/оклады чужих сотрудников).
  booking_manager: ['dashboard','crm','bookings','reviews','transactions','payroll'],
  hotel_admin:     ['dashboard','crm','bookings','reviews','transactions','payroll'],
  // Дашборд + «Реклама» (21.08.2026) — см. server/config/constants.js.
  marketing:       ['dashboard','crm','advertising','reviews'],
  // Инвестор: карточки отелей + P&L/P&L УК по своим объектам; «Инвесторам» —
  // точечно через canViewInvestors (Sidebar); «Бронирования» — только брони TL
  // по своим объектам, без оплат (02.10.2026), см. server/config/constants.js.
  investor:        ['dashboard','reports','bookings'],
};

// Типы объектов, доступные для выдачи инвестору (форма пользователя).
export const INVESTOR_SCOPE_PROPERTY_TYPES = ['hotel', 'rental', 'management_company'];
export const isInvestor = user => !!user && user.role === ROLES.INVESTOR;

// Роли «стойки» — одинаковый ограниченный доступ (§3.7):
//   • Дашборд: только вкладка «Обзор», зафиксирован на текущем месяце;
//   • Бронирования: раздел целиком (все брони);
//   • Журнал операций: только СВОИ операции (created_by = текущий пользователь) —
//     ограничение применяется на сервере (routes/journal.js), не только в UI.
export const DESK_ROLES = ['booking_manager', 'hotel_admin'];

// Объекты (short_name), доступные ролям «стойки» в фильтре «Объект» журнала операций.
// Остальные объекты в выпадающем списке для этих ролей скрыты.
export const DESK_JOURNAL_PROPERTY_SHORT_NAMES = ['М19', 'М29', 'Н44', 'Н44-офис'];

// Объекты (short_name), доступные ролям «стойки» в фильтре «Объект» Журнала
// бронирований. Без «Н44-офис» — это касса, а не объект с бронями TL.
export const DESK_BOOKINGS_PROPERTY_SHORT_NAMES = ['Н44', 'М19', 'М29'];

export const BOOKING_STATUSES = [
  { value: 'confirmed',    label: 'Подтверждено',  color: 'blue'   },
  { value: 'checked_in',  label: 'Заехал',         color: 'green'  },
  { value: 'checked_out', label: 'Выехал',         color: 'gray'   },
  { value: 'cancelled',   label: 'Отменено',       color: 'red'    },
  { value: 'no_show',     label: 'Не приехал',     color: 'orange' },
];

export const BOOKING_STATUS_LABELS = Object.fromEntries(BOOKING_STATUSES.map(s => [s.value, s.label]));

export const ROOM_TYPES = [
  { value: 'standard',        label: 'Стандарт'             },
  { value: 'single_standard', label: 'Одноместный стандарт' },
  { value: 'mansard',         label: 'Мансардный стандарт'  },
  { value: 'semisuit',        label: 'Полулюкс'             },
  { value: 'comfort',         label: 'Комфорт'              },
  { value: 'superior',        label: 'Супериор'             },
  { value: 'deluxe',          label: 'Делюкс'               },
  { value: 'suite',           label: 'Сюит'                 },
  { value: 'family',          label: 'Семейный'             },
  { value: 'dorm',            label: 'Дормитори'            },
  { value: 'apartment',       label: 'Апартаменты'          },
];

// Служебные категории номеров TravelLine (отмены/незаезды) — исключаются из статистики.
// Зеркало server/config/constants.js.
export const TL_SERVICE_ROOM_CATEGORIES = ['для отмен и незаездов'];

export const ROOM_STATUSES = [
  { value: 'clean',         label: 'Чистый',           color: 'green'  },
  { value: 'dirty',         label: 'Грязный',           color: 'red'    },
  { value: 'inspected',     label: 'Проверен',          color: 'blue'   },
  { value: 'out_of_order',  label: 'Не обслуживается',  color: 'gray'   },
  { value: 'do_not_disturb',label: 'Не беспокоить',     color: 'orange' },
];

// group: 'cash' | 'terminal' | 'internet' | 'bank' | 'ota'
// requires_settlement: true — требует сопоставления с банковским импортом
// commission_model: 'none' | 'immediate_in_purpose' | 'batch_rko' | 'report_only'
export const PAYMENT_METHODS = [
  { value: 'cash',           label: 'Наличные',                   group: 'cash',     requires_settlement: false, commission_model: 'none' },
  { value: 'terminal',       label: 'Эквайринг — картой',         group: 'terminal', requires_settlement: true,  commission_model: 'batch_rko' },
  { value: 'qr_sbp',         label: 'Эквайринг — СБП (QR)',       group: 'terminal', requires_settlement: true,  commission_model: 'immediate_in_purpose' },
  { value: 'online_website', label: 'Интернет — оплата на сайте', group: 'internet', requires_settlement: true,  commission_model: 'immediate_in_purpose' },
  { value: 'link',           label: 'Интернет — по ссылке',       group: 'internet', requires_settlement: true,  commission_model: 'report_only' },
  { value: 'ota',            label: 'Через OTA',                  group: 'ota',      requires_settlement: true,  commission_model: 'report_only' },
  { value: 'bank_transfer',  label: 'Безнал на р/с',              group: 'bank',     requires_settlement: true,  commission_model: 'none' },
];

export const PAYMENT_METHOD_LABELS = Object.fromEntries(PAYMENT_METHODS.map(m => [m.value, m.label]));

// ─── СВЕРКА ПО ПЛАТЕЖАМ (TravelLine BillingReport) — зеркало server/config/constants.js
export const PAYMENT_RECON_ISSUE_TYPES = [
  { value: 'ok',                      label: 'Совпадает' },
  { value: 'method_mismatch',         label: 'Способ оплаты не совпадает' },
  { value: 'missing_payment',         label: 'Нет платежа в программе' },
  { value: 'orphan_payment',          label: 'Есть у нас, нет в отчёте TL' },
  { value: 'amount_mismatch',         label: 'Сумма не совпадает' },
  { value: 'cancelled_charge_standing', label: 'Отмена/незаезд с висящей суммой' },
  { value: 'unmapped_method',         label: 'Неизвестный способ оплаты в отчёте' },
];
export const PAYMENT_RECON_ISSUE_LABELS = Object.fromEntries(PAYMENT_RECON_ISSUE_TYPES.map(t => [t.value, t.label]));

// Модель расчётов с OTA по платежу: prepaid (дебиторка) / pay_at_hotel (кредиторка-комиссия).
export const OTA_PAYMENT_KINDS = [
  { value: 'prepaid',      label: 'Площадка удержала оплату' },
  { value: 'pay_at_hotel', label: 'Гость платит на стойке'   },
];

export const PAYMENT_TYPES = [
  { value: 'prepayment', label: 'Предоплата'    },
  { value: 'full',       label: 'Полная оплата' },
  { value: 'deposit',    label: 'Депозит'       },
  { value: 'extra',      label: 'Доп. услуги'   },
  { value: 'refund',     label: 'Возврат'       },
];

// Статьи расходов хранятся в БД (expense_categories + expense_items).
// Фронтенд получает их через GET /api/expense-categories при загрузке.
// Флаг is_loan=1 означает, что нужен выбор контрагента займа.
// Основные объекты + внутренние контрагенты (Л13, АК) + фонды/виртуальные
// сущности. Значения = short_name property; бэкенд мапит в counterparty_property_id.
export const LOAN_COUNTERPARTIES = [
  'УК', 'Н44', 'Н44-офис', 'М19', 'М29',
  'Л13', 'АК', 'ВЕ', 'РШ',
  'Фонд НЗ Н44', 'Фонд НЗ М19', 'Фонд НЗ М29', 'Фонд НЗ Н44-офис', 'Фонд НЗ УК',
  'Фонд Налоги', 'Фонд Турналог',
  'Дивиденды Доминанта', 'Прибыль Н44',
];

export const PROPERTY_TYPES = [
  { value: 'hotel',                 label: 'Отель'                  },
  { value: 'rental',                label: 'Арендная недвижимость'  },
  { value: 'management_company',    label: 'Управляющая компания'   },
  { value: 'internal_counterparty', label: 'Внутренний контрагент'  },
];

// Типы объектов без операционного учёта (нет доходов, расходов, бронирований)
export const PASSIVE_PROPERTY_TYPES = new Set(['internal_counterparty']);

// Основные объекты, которые имеют право отчислять/погашать через общефондовые
// «котлы» (Налоги с оборота, Турналог, дивиденды) — зеркало server/config/constants.js.
export const MAIN_PROPERTY_TYPES = new Set(['hotel', 'rental', 'management_company']);

// is_internal=true — внутренний доход, исключается из P&L
// requires_counterparty=true — нужен выбор объекта-контрагента (займы)
export const INCOME_TYPES = {
  hotel: [
    { value: 'accommodation_direct', label: 'Размещение — прямое бронирование' },
    // Виртуальный подтип — выделяется на сервере из accommodation_direct по
    // methods='online_website' (продажи через сайт), в payments не хранится.
    { value: 'accommodation_direct_site', label: 'Размещение — напрямую (сайт)' },
    { value: 'accommodation_ota',    label: 'Размещение — через OTA'           },
    { value: 'accommodation_extension', label: 'Продление проживания'          },
    { value: 'early_check_in',       label: 'Ранний заезд'                     },
    { value: 'late_check_out',       label: 'Поздний выезд'                    },
    { value: 'extra_services',       label: 'Дополнительные услуги'            },
    { value: 'damage_fee',           label: 'Штраф за порчу'                   },
    { value: 'fine',                 label: 'Штраф'                            },
    { value: 'deposit',              label: 'Залог'                            },
    { value: 'cancellation_fee',     label: 'Штраф за отмену'                  },
    { value: 'supplier_refund',      label: 'Возврат от поставщика'            },
    // Партнёрские услуги (02.10.2026): доход от партнёра за размещение его сервиса
    // (напр. «Бери заряд»), отель сам услугу не продаёт. Идёт в «Прочие доходы»
    // отдельной строкой, раскрытие — по названию услуги (services). Не доп.услуга:
    // в KPI-3 не участвует.
    { value: 'partner_services',     label: 'Партнёрские услуги'               },
    { value: 'other',                label: 'Прочие доходы'                    },
  ],
  rental: [
    { value: 'monthly_rent',     label: 'Аренда офисов'         },
    { value: 'ku_reimbursement', label: 'Возмещение КУ'         },
    { value: 'supplier_refund',  label: 'Возврат от поставщика' },
    { value: 'other',            label: 'Прочие доходы'         },
  ],
  management_company: [
    { value: 'management_fee',   label: 'Вознаграждение за управление', requires_counterparty: true },
    { value: 'deposit_interest', label: 'Проценты от депозитов' },
    { value: 'supplier_refund',  label: 'Возврат от поставщика' },
    { value: 'other',            label: 'Прочие доходы'         },
  ],
  internal_counterparty: [
    { value: 'other', label: 'Прочие доходы' },
  ],
  // Внутренние/финансовые движения вынесены в отдельный домен (см. ниже).
};

// Доходы вне операционного P&L (но в ДДС/кассе/журнале) — зеркально is_investor.
// 'deposit' — залог: получен (касса), но не выручка (возвращается гостю).
// 'ku_reimbursement' (Возмещение КУ) с 07.2026 — обычный доход, наравне с
// monthly_rent (компенсирует реальный коммунальный расход в P&L Н44-офис).
export const NON_PL_INCOME_TYPES = new Set(['deposit']);

// Доплаты сверх брони (доход по проживанию помимо основной суммы из TravelLine):
// привязываются к TL-броне по external_id и формируют «всего по гостю». Зеркало
// server/config/constants.js. Депозит сюда НЕ входит — он не выручка.
// accommodation_extension — продление проживания (доп. ночи сверх исходной брони):
// вносится отдельной операцией с привязкой к брони, в P&L отдельной строкой.
export const SURCHARGE_INCOME_TYPES = new Set([
  'early_check_in', 'late_check_out', 'extra_services', 'damage_fee', 'fine',
  'accommodation_extension',
]);

// Типы дохода, привязываемые к TL-броне (показывают пикер): доплаты + депозит.
export const BOOKING_LINK_INCOME_TYPES = new Set([...SURCHARGE_INCOME_TYPES, 'deposit']);

// Внутренние/финансовые движения — отдельный домен internal_movements.
export const INTERNAL_MOVEMENT_KINDS = [
  { value: 'overnight',          label: 'Овернайт'             },
  { value: 'emergency_fund',     label: 'Фонд НЗ'              },
  { value: 'tax_turnover_fund',  label: 'Фонд Налоги с оборота'},
  { value: 'tax_tourist_fund',   label: 'Фонд Турналог'        },
  { value: 'dividends',          label: 'Дивиденды'            },
  // 14.09.2026: спецсчета «Прибыль Н44»/«Дивиденды Доминанта» разведены на два
  // шага (см. блок ниже). 'dividends' — только прямая выплата АК/РШ.
  { value: 'dividend_reserve',   label: 'Перевод на счёт нераспределённой прибыли' },
  { value: 'dividend_payout',    label: 'Выплата дивидендов'   },
  { value: 'cash_transfer',      label: 'Снятие наличных'       },
  // 'rearrangement' — намеренно ОДНОСТОРОННЯЯ корректировка остатка, без парной
  // ноги (в отличие от cash_transfer). Баланс книги ведётся вручную оператором.
  { value: 'rearrangement',      label: 'Перестановка'          },
  // Кэш-пулинг объект↔УК — см. server/config/constants.js.
  { value: 'pooling',            label: 'Перевод на счёт УК (Овернайт)' },
  { value: 'loan',               label: 'Заём'                 },
];
// Получатели ПРЯМОЙ выплаты (kind='dividends') — только АК/РШ, см. server.
export const DIVIDEND_RECIPIENT_SHORT_NAMES = ['АК', 'РШ'];

// ─── Спецсчета накопления дивидендов: «резерв → выплата» (зеркало сервера) ─
export const N44_DIVIDEND_POOL_SHORT_NAME = 'Прибыль Н44';
export const DOMINANT_DIVIDEND_POOL_SHORT_NAME = 'Дивиденды Доминанта';
export const DIVIDEND_RESERVE_TARGET_SHORT_NAMES = [N44_DIVIDEND_POOL_SHORT_NAME, DOMINANT_DIVIDEND_POOL_SHORT_NAME];
export const DIVIDEND_PAYOUT_SOURCE_SHORT_NAMES = [N44_DIVIDEND_POOL_SHORT_NAME, DOMINANT_DIVIDEND_POOL_SHORT_NAME];
// «Дивиденды Доминанта» — внутренний накопительный счёт, никогда не бывает
// получателем выплаты (14.09.2026, уточнение владельца): из «Прибыль Н44» его
// доля уходит туда как dividend_reserve (резерв), не payout. Получателем
// выплаты может быть только реальная компания/объект — см. ниже.
export const N44_POOL_PAYOUT_RECIPIENT_SHORT_NAMES = ['АК', 'РШ'];
export const DOMINANT_PAYOUT_PURPOSE_SHORT_NAMES = ['ООО Доминант', 'Волынский', 'Фонтанка', 'Лейсан Валиуллина'];
export const HOLDER_FINAL_PAYOUT_RECIPIENT_SHORT_NAMES = [...N44_POOL_PAYOUT_RECIPIENT_SHORT_NAMES, ...DOMINANT_PAYOUT_PURPOSE_SHORT_NAMES];
// Объекты с наличной кассой — для cash_transfer.
export const HAS_CASH_TILL_SHORT_NAMES = ['Н44', 'Н44-офис', 'М19', 'М29'];
// Роли с полным финансовым доступом (создают/правят любые внутренние движения).
export const FINANCIAL_ROLES = new Set(['owner', 'director', 'financier']);
// Пользователи (по username) с точечным доступом к займам между объектами
// независимо от роли (зеркало server/config/constants.js).
export const LOAN_ACCESS_USERNAMES = ['guseva'];
// Может ли пользователь вести займы: финансовые роли — всегда; иначе точечно по username.
export function canManageLoans(user) {
  if (!user) return false;
  if (FINANCIAL_ROLES.has(user.role)) return true;
  return LOAN_ACCESS_USERNAMES.includes(user.username);
}
// Совмещение должностей (вторая и последующая должность одному сотруднику) —
// жёсткий список по username (не по роли), зеркало server/config/constants.js.
export const POSITION_COMBINE_USERNAMES = ['admin', 'semen.vydrin'];
export function canCombinePositions(user) {
  return !!user && POSITION_COMBINE_USERNAMES.includes(user.username);
}
// KPI уровень 5 — персонально для старшего администратора (Гусева Т.В.),
// зеркало server/config/constants.js.
export const SENIOR_ADMIN_KPI_USERNAMES = ['guseva'];
export const SENIOR_ADMIN_KPI_PROPERTIES = ['М19', 'М29', 'Н44'];
export function canViewSeniorAdminKpi(user) {
  if (!user) return false;
  if (FINANCIAL_ROLES.has(user.role)) return true;
  return SENIOR_ADMIN_KPI_USERNAMES.includes(user.username);
}
// «Смены»: шахматки по отделам — зеркало server/config/constants.js.
export const SHIFT_DEPARTMENTS = [
  { value: 'hotel_admin',       label: 'Администраторы' },
  { value: 'booking_manager',   label: 'Отдел бронирования' },
  { value: 'housekeeper_h44',   label: 'Горничные Н44',      rate_mode: 'checkout_tiered', properties: ['Н44'] },
  { value: 'housekeeper_m1929', label: 'Горничные М19/М29',  rate_mode: 'checkout_tiered', properties: ['М19', 'М29'], combined: true },
];
export const SHIFT_DEPT_ACCESS_BY_ROLE = {
  hotel_admin:     ['hotel_admin', 'housekeeper_h44'],
  booking_manager: ['booking_manager', 'housekeeper_m1929'],
};
export const SHIFT_DEPT_EXTRA_BY_USERNAME = { guseva: ['housekeeper_m1929'] };
export function shiftDeptAccessList(user) {
  if (!user) return [];
  if (FINANCIAL_ROLES.has(user.role)) return SHIFT_DEPARTMENTS.map(d => d.value);
  const base = SHIFT_DEPT_ACCESS_BY_ROLE[user.role] || [];
  const extra = SHIFT_DEPT_EXTRA_BY_USERNAME[user.username] || [];
  return [...new Set([...base, ...extra])];
}
export const INTERNAL_MOVEMENT_DIRECTIONS = [
  { value: 'out', label: 'Списание / выдача'   },
  { value: 'in',  label: 'Возврат / получение' },
];
export const LOAN_ROLES = [
  { value: 'lender',   label: 'Мы кредитор (дали в долг)' },
  { value: 'borrower', label: 'Мы заёмщик (взяли в долг)' },
];

// historical filter only — новые внутренние движения через internal_movements.
export const INTERNAL_INCOME_TYPES = new Set([
  'loan_received', 'loan_repayment', 'overnight_return', 'emergency_fund_return',
]);
export const LOAN_INCOME_TYPES = new Set(['loan_received', 'loan_repayment']);

// Статья расхода (requires_employee) → должности, чьи сотрудники могут по ней
// получать выплату. Нужен для выпадающего списка «Сотрудник»: после выбора
// статьи показываем только людей с этой должностью (employee_positions,
// is_active=1). Статьи, которых здесь нет (напр. «KPI старший администратор»),
// не фильтруются — показываем всех.
export const EXPENSE_ITEM_POSITIONS = {
  'Администраторы':              ['receptionist'],
  'KPI Администраторы':          ['receptionist'],
  'Горничные (уборка)':          ['housekeeper'],
  'KPI Уборка':                  ['housekeeper'],
  'Отдел бронирования':          ['booking_manager'],
  'KPI Отдел Бронирования':      ['booking_manager'],
  'Финансовый директор':         ['finance_director'],
  'Коммерческий директор':       ['commercial_director'],
  'KPI комм. дир.':              ['commercial_director'],
  'Директор по развитию':        ['development_director'],
  'Программист':                 ['programmer'],
  'СММ':                         ['smm_manager'],
  'KPI SMM':                     ['smm_manager'],
  'Управляющая':                 ['general_manager'],
};

// Сотрудники, подходящие под статью расхода; selectedId — уже выбранный
// остаётся в списке всегда. Нет сопоставления или никого не нашлось — все.
export function employeesForItem(employees, itemName, selectedId) {
  const positions = EXPENSE_ITEM_POSITIONS[itemName];
  if (!positions) return employees;
  const filtered = employees.filter(e =>
    String(e.id) === String(selectedId) || (e.positions || []).some(p => positions.includes(p)));
  return filtered.length ? filtered : employees;
}

// Отделы для справочника сотрудников (Справочники → Сотрудники): порядок = порядок
// блоков. Сотрудник попадает в отдел своей первой активной должности из списка
// (приоритет — порядок отделов ниже); без должности — «Без должности».
export const EMPLOYEE_DEPARTMENTS = [
  { key: 'top',        label: 'Топ-менеджмент',       positions: ['commercial_director', 'finance_director', 'development_director'] },
  { key: 'management', label: 'Управление',           positions: ['general_manager', 'operations_manager'] },
  { key: 'front',      label: 'Администраторы',       positions: ['receptionist'] },
  { key: 'booking',    label: 'Отдел бронирования',   positions: ['booking_manager'] },
  { key: 'housekeep',  label: 'Горничные',            positions: ['housekeeper'] },
  { key: 'marketing',  label: 'Маркетинг и СММ',      positions: ['smm_manager', 'marketer'] },
  { key: 'it',         label: 'Разработка',           positions: ['programmer'] },
];

export const EMPLOYEE_POSITIONS = [
  { value: 'housekeeper',         label: 'Горничная',                    pay_type: 'shift',  requires_property: true  },
  { value: 'receptionist',        label: 'Администратор',                 pay_type: 'shift',  requires_property: true  },
  { value: 'booking_manager',     label: 'Менеджер отдела бронирования', pay_type: 'shift',  requires_property: false },
  { value: 'smm_manager',         label: 'Менеджер СММ',                 pay_type: 'salary', requires_property: false },
  { value: 'marketer',           label: 'Маркетолог',                   pay_type: 'salary', requires_property: false },
  { value: 'finance_director',      label: 'Финансовый директор',         pay_type: 'salary', requires_property: false },
  { value: 'commercial_director',   label: 'Коммерческий директор',       pay_type: 'salary', requires_property: false },
  { value: 'development_director',  label: 'Директор по развитию',        pay_type: 'salary', requires_property: false },
  { value: 'operations_manager',    label: 'Операционный менеджер',       pay_type: 'salary', requires_property: false },
  { value: 'general_manager',       label: 'Управляющая',                 pay_type: 'salary', requires_property: false },
  // «Разработчик» = «Программист» — та же роль, что и статья расхода ФОТ
  // «Программист» — название держим одинаковым, не плодим синонимы.
  { value: 'programmer',            label: 'Программист',                 pay_type: 'salary', requires_property: false },
];

// Должности, для которых ставка рассчитывается автоматически по справочнику
// housekeeping_rates (зависит от количества выездов на объекте в день смены)
export const AUTO_RATE_POSITIONS = new Set(['housekeeper']);

// Быстрый lookup requires_property
export const POSITION_REQUIRES_PROPERTY = Object.fromEntries(
  EMPLOYEE_POSITIONS.map(p => [p.value, p.requires_property])
);

export const POSITION_PAY_TYPE = Object.fromEntries(
  EMPLOYEE_POSITIONS.map(p => [p.value, p.pay_type])
);

export const POSITION_LABELS = Object.fromEntries(
  EMPLOYEE_POSITIONS.map(p => [p.value, p.label])
);

export const PAY_KINDS = [
  { value: 'advance',       label: 'Аванс (оклад)',  day: 25 },
  { value: 'salary_final',  label: 'Расчёт (оклад)', day: 10 },
  { value: 'shift_first',   label: 'Смены 1–15',     day: 25 },
  { value: 'shift_second',  label: 'Смены 16–конец', day: 10 },
  { value: 'kpi',           label: 'KPI',            day: 25 },
];

export const PAY_KIND_LABELS = Object.fromEntries(PAY_KINDS.map(k => [k.value, k.label]));

// ─── KPI «ПРЯМЫЕ ПРОДАЖИ» (уровень 1 из 3) ───────────────────────────────────
// Источник: отчёт WebPMS «Эффективность работы менеджеров» (колонка «Источник»)
// либо ручной ввод. Продажа засчитывается тому, кто создал бронь («Создал»).
export const KPI_DIRECT_SALE_CHANNELS = ['От стойки', 'По звонку', 'Мессенджеры', 'Email', 'ВКонтакте', 'Мобильный экстранет'];
// Ставка KPI от стоимости брони (%).
export const KPI_DIRECT_SALE_PCT = 0.3;

// ─── РЕКЛАМА (21.08.2026) ────────────────────────────────────────────────────
export const ADVERTISING_PLATFORMS = [
  { value: 'yandex', label: 'Яндекс.Бизнес' },
  { value: 'vk',     label: 'ВКонтакте' },
];

// Отдел сотрудника для KPI — определяет статью «ФОТ → KPI → …» по умолчанию
// при начислении (employees.kpi_department, отдельно от users.role).
export const KPI_DEPARTMENTS = [
  { value: 'commercial_director', label: 'Коммерческий директор', expense_item_name: 'KPI комм. дир.' },
  { value: 'hotel_admin',         label: 'Администраторы',        expense_item_name: 'KPI Администраторы' },
  { value: 'housekeeper',         label: 'Уборка',                 expense_item_name: 'KPI Уборка' },
  { value: 'booking_manager',     label: 'Отдел бронирования',    expense_item_name: 'KPI Отдел Бронирования' },
];
export const KPI_DEPARTMENT_LABELS = Object.fromEntries(KPI_DEPARTMENTS.map(d => [d.value, d.label]));

// ─── KPI «ДОП. УСЛУГИ» (уровень 3 из 3) ──────────────────────────────────────
// Командный фонд без персонализации (как отзывы, уровень 2) — % фиксирован,
// без вариаций по объекту (решение владельца).
export const EXTRA_SERVICES_KPI_PCT = 10;
export const EXTRA_SERVICES_KPI_DEPARTMENT_BY_PROPERTY = {
  'Н44': 'hotel_admin',
  'М19': 'booking_manager',
  'М29': 'booking_manager',
};

// ─── KPI «ПЛАН ПО ВЫРУЧКЕ» (уровень 4 из 4) ──────────────────────────────────
// Ступенчатая накопительная формула — каждая ступень даёт % от своей части
// выручки (как прогрессивный налог), вклады складываются. До 95% — 0, выше
// 110% KPI больше не растёт (верхняя ступень ограничена).
export const REVENUE_PLAN_KPI_TIERS = [
  { min_pct: 95,  max_pct: 100, rate: 1 },
  { min_pct: 100, max_pct: 105, rate: 5 },
  { min_pct: 105, max_pct: 110, rate: 10 },
];
export const REVENUE_PLAN_KPI_SPLIT_BY_PROPERTY = {
  'Н44': { hotel_admin: 70, booking_manager: 30 },
  'М19': { booking_manager: 70, hotel_admin: 30 },
  'М29': { booking_manager: 70, hotel_admin: 30 },
};

// Порядок строк доходов в P&L — выводится из INCOME_TYPES.hotel (§3.8).
export const INCOME_ORDER = INCOME_TYPES.hotel.map(t => t.value);

// Метки провайдеров клиринга (City Ledger / отчёт /clearing) — §3.8.
export const PROVIDER_LABELS = {
  bank_transfer: 'Р/с (банковский перевод)',
  acq_card:      'Эквайринг — картой',
  acq_sbp:       'Эквайринг — СБП (QR)',
  acq_site:      'Интернет — оплата на сайте',
  acq_link:      'Интернет — по ссылке',
  ota:           'OTA',
};

// План счетов отчёта «Баланс» — зеркало server/config/constants.js (§3.8).
// Используется для вкладки «Начальные остатки» (Settings) и порядка строк.
export const BALANCE_ACCOUNTS = [
  { code: 'm29_cash', label: 'Наличная касса', group: 'М29', kind: 'cash',           ref: 'М29' },
  { code: 'm29_main', label: 'Основной р/с',    group: 'М29', kind: 'bank_main',      ref: 'М29' },
  { code: 'm29_fund', label: 'Фонд НЗ',         group: 'М29', kind: 'fund_emergency', ref: 'М29' },
  { code: 'm19_cash', label: 'Наличная касса', group: 'М19', kind: 'cash',           ref: 'М19' },
  { code: 'm19_main', label: 'Основной р/с',    group: 'М19', kind: 'bank_main',      ref: 'М19' },
  { code: 'm19_fund', label: 'Фонд НЗ',         group: 'М19', kind: 'fund_emergency', ref: 'М19' },
  { code: 'n44_cash', label: 'Наличная касса', group: 'Н44', kind: 'cash',           ref: 'Н44' },
  { code: 'n44_main', label: 'Основной р/с',    group: 'Н44', kind: 'bank_main',      ref: 'Н44' },
  { code: 'n44_fund', label: 'Фонд НЗ',         group: 'Н44', kind: 'fund_emergency', ref: 'Н44' },
  { code: 'n44_div',  label: 'Дивиденды',       group: 'Н44', kind: 'dividends_cp',   ref: 'Прибыль Н44' },
  { code: 'n44o_cash', label: 'Наличная касса', group: 'Н44-офис', kind: 'cash',           ref: 'Н44-офис' },
  { code: 'n44o_main', label: 'Основной р/с',    group: 'Н44-офис', kind: 'bank_main',      ref: 'Н44-офис' },
  { code: 'n44o_fund', label: 'Фонд НЗ',         group: 'Н44-офис', kind: 'fund_emergency', ref: 'Н44-офис' },
  { code: 'uk_main', label: 'Основной р/с', group: 'УК', kind: 'bank_main',      ref: 'УК' },
  { code: 'uk_fund', label: 'Фонд НЗ',      group: 'УК', kind: 'fund_emergency', ref: 'УК' },
  { code: 'l13_main', label: 'Основной р/с', group: 'Л13', kind: 'bank_main',      ref: 'Л13' },
  { code: 'l13_fund', label: 'Фонд',         group: 'Л13', kind: 'fund_emergency', ref: 'Л13' },
  { code: 'ak_personal',  label: 'Личный АК',             group: 'Общие', kind: 'loan_cp',          ref: 'АК' },
  { code: 'fund_overnight',label:'Овернайт',              group: 'Общие', kind: 'fund_overnight',   ref: null },
  { code: 'fund_tourist', label: 'Фонд Турналог',         group: 'Общие', kind: 'fund_tax_tourist', ref: null },
  { code: 'fund_turnover',label: 'Фонд Налоги с оборота', group: 'Общие', kind: 'fund_tax_turnover',ref: null },
  { code: 'div_dominanta',label: 'Дивиденды Доминанта',   group: 'Общие', kind: 'dividends_cp',     ref: 'Дивиденды Доминанта' },
];

// Группы-объекты (для разделения в UI отчёта «Баланс»).
export const BALANCE_OBJECT_GROUPS = ['Н44', 'М29', 'М19', 'Н44-офис', 'УК', 'Л13'];
// Порядок всех групп в отчёте «Баланс» (объекты, затем общие).
export const BALANCE_GROUP_ORDER = [...BALANCE_OBJECT_GROUPS, 'Общие'];

// ─── P&L: РАСПРЕДЕЛЕНИЕ EBITDA (фонды → доля УК/инвестора) ──────────────────
// Зеркало server/config/constants.js — единый источник и для водопада здесь
// (Reports.jsx, чисто отображение), и для серверного расчёта Доли УК, которая
// реально формирует выручку УК (income_type='management_fee' на объекте «УК»).
// Проценты/базы менялись 25.08.2026 — новые действуют только с
// PL_FUND_ROWS_EFFECTIVE_FROM, прошлые месяцы считаются по LEGACY (см.
// fundRowsForPeriod, используется в Reports.jsx наравне с server-версией).
export const PL_FUND_ROWS_LEGACY = [
  { key: 'kpi_senior_admin', label: 'KPI старший админ',     pct: 1, base: 'ebitda',  onlyProps: ['М19', 'М29', 'Н44'] },
  { key: 'tax_turnover',     label: 'Налоги с оборота', pct: 2, base: 'revenue_net_ota', excludeProps: ['УК'] },
  { key: 'tourist_tax',      label: 'Турналог',              pct: 1, base: 'revenue', onlyProps: ['М19', 'Н44'] },
  { key: 'emergency_fund',   label: 'Фонд НЗ',               pct: 1, base: 'ebitda'  },
];
export const PL_FUND_ROWS_V2 = [
  { key: 'kpi_senior_admin', label: 'KPI старший админ',     pct: 1, base: 'ebitda',  onlyProps: ['М19', 'М29', 'Н44'] },
  { key: 'tax_turnover',     label: 'Налоги с оборота', pct: 3, base: 'revenue', excludeProps: ['УК'] },
  { key: 'tourist_tax',      label: 'Турналог',              pct: 2, base: 'revenue', onlyProps: ['М19', 'Н44'] },
  { key: 'emergency_fund',   label: 'Фонд НЗ',               pct: 2, base: 'revenue' },
];
// Фонд НЗ 2%→1% с августа 2026 (решение владельца 03.09.2026).
export const PL_FUND_ROWS = [
  { key: 'kpi_senior_admin', label: 'KPI старший админ',     pct: 1, base: 'ebitda',  onlyProps: ['М19', 'М29', 'Н44'] },
  { key: 'tax_turnover',     label: 'Налоги с оборота', pct: 3, base: 'revenue', excludeProps: ['УК'] },
  { key: 'tourist_tax',      label: 'Турналог',              pct: 2, base: 'revenue', onlyProps: ['М19', 'Н44'] },
  { key: 'emergency_fund',   label: 'Фонд НЗ',               pct: 1, base: 'revenue' },
];
export const PL_FUND_ROWS_EFFECTIVE_FROM = '2026-07';
// Форма P&L с сентября 2026 (группы «ФОТ и KPI», «Эквайринг и комиссии»,
// «Маркетинг» и т.д.) — раскладку делает сервер (plLayout.js), клиент получает
// data.expense_layout=4. Дата — зеркало server/config/constants.js.
export const PL_LAYOUT_V4_EFFECTIVE_FROM = '2026-09';
// Типы дохода группы «Штрафы» в P&L — их транзакции показываются с описанием.
export const PL_FINE_INCOME_TYPES = ['damage_fee', 'fine', 'cancellation_fee'];
export const PL_FUND_ROWS_V3_EFFECTIVE_FROM = '2026-08';
export const fundRowsForPeriod = period => {
  const p = String(period).slice(0, 7);
  if (p < PL_FUND_ROWS_EFFECTIVE_FROM) return PL_FUND_ROWS_LEGACY;
  if (p < PL_FUND_ROWS_V3_EFFECTIVE_FROM) return PL_FUND_ROWS_V2;
  return PL_FUND_ROWS;
};
export const PL_SHARE_PROPS = ['М19', 'М29', 'Н44', 'Н44-офис'];

// ─── «ИНВЕСТОРАМ»: расчёты с владельцами управляемых отелей ────────────────
// Зеркало server/config/constants.js — см. комментарий там.
export const INVESTOR_HOLDERS = [
  { key: 'ak',       label: 'АК',       ownership_short_name: 'АК', payout_short_name: 'АК',                  accumulates: false, opening_balance_code: null },
  { key: 'dominant', label: 'Доминант', ownership_short_name: 'ВЕ', payout_short_name: 'Дивиденды Доминанта', accumulates: true,  opening_balance_code: 'div_dominanta' },
  { key: 'rsh',      label: 'РШ',       ownership_short_name: 'РШ', payout_short_name: 'РШ',                  accumulates: false, opening_balance_code: null },
];
export const INVESTOR_SCOPE_PROPERTIES = ['М19', 'М29', 'Н44', 'Н44-офис', 'УК', 'Л13'];
export const INVESTOR_MECHANISM_START_PERIOD = '2026-07';
// Объекты с ручным вводом «Чистая прибыль»/«Выплачено» (учёт ведётся не здесь,
// см. server/config/constants.js) — единственный случай сегодня: Л13.
export const INVESTOR_MANUAL_PROPERTIES = ['Л13'];
// Строка «Выкуп» относится только к М19 (владелец, 02.09.2026) — остальные
// объекты её не показывают вообще, см. server/config/constants.js.
export const RENT_BUYOUT_PROPS = ['М19'];
// Точечный доступ по username, БЕЗ авто-разрешения по роли — в отличие от
// canManageLoans выше. semen.vydrin (director) добавлен 30.08.2026 решением
// владельца — раньше был намеренно исключён, решение пересмотрено.
export const INVESTOR_ACCESS_USERNAMES = ['admin', 'liudmila.buzh', 'semen.vydrin'];
export function canAccessInvestors(user) {
  if (!user) return false;
  return INVESTOR_ACCESS_USERNAMES.includes(user.username);
}
// Инвестор с привязанным держателем видит раздел «Инвесторам» только по себе
// и своим объектам, без ввода (02.10.2026) — зеркало server/config/constants.js.
export const INVESTOR_HOLDER_BY_USERNAME = {
  'valentin.enokaev': 'dominant',
  'roman.shatokhin':  'rsh',
};
export function investorHolderKeyFor(user) {
  if (!isInvestor(user)) return null;
  return INVESTOR_HOLDER_BY_USERNAME[user.username] || null;
}
export function canViewInvestors(user) {
  return canAccessInvestors(user) || !!investorHolderKeyFor(user);
}

export const PL_SHARE_ROWS = [
  { key: 'uk_share',       label: 'Доля УК',       pct: 30 },
  { key: 'investor_share', label: 'Доля инвестора', pct: 70 },
];

// Прямые/внутренние каналы — не площадки, сверка с площадкой их не касается.
// См. server/config/constants.js.
export const NON_OTA_SOURCE_NAMES = ['Прямое (сайт)', 'Прямое (звонок)', 'Корпоратив'];

// ─── CRM (10.10.2026, по структуре CRM Surfside Manager) ──────────────────────
// Кто работает с CRM: раздел 'crm' в ROLE_NAV + эти же роли на сервере
// (routes/crm/*). Удаление (мягкое) — только собственник.
export const CRM_ROLES = ['owner', 'director', 'booking_manager', 'hotel_admin', 'marketing'];
// Каналы обращения (лид) и ленты.
export const CRM_CHANNELS = [
  { value: 'phone',     label: 'Телефон' },
  { value: 'whatsapp',  label: 'WhatsApp' },
  { value: 'telegram',  label: 'Telegram' },
  { value: 'max',       label: 'Max' },
  { value: 'email',     label: 'Email' },
  { value: 'site',      label: 'Сайт' },
  { value: 'avito',     label: 'Авито' },
  { value: 'ota',       label: 'OTA' },
  { value: 'walk_in',   label: 'Пришёл сам' },
  { value: 'other',     label: 'Другое' },
];
export const CRM_LOST_REASONS = [
  { value: 'no_reply',      label: 'Не отвечает' },
  { value: 'price',         label: 'Дорого' },
  { value: 'no_rooms',      label: 'Нет мест на даты' },
  { value: 'other_option',  label: 'Выбрал другой вариант' },
  { value: 'booked_via_ota',label: 'Забронировал через OTA' },
  { value: 'trip_cancelled',label: 'Поездка отменена' },
  { value: 'spam',          label: 'Спам' },
  { value: 'wrong_contact', label: 'Ошибочный контакт' },
  { value: 'other',         label: 'Другое' },
];
// Ручные типы записей ленты; stage_change/task/system пишет программа.
export const CRM_ACTIVITY_TYPES = [
  { value: 'note',    label: 'Заметка' },
  { value: 'call',    label: 'Звонок' },
  { value: 'message', label: 'Сообщение' },
  { value: 'email',   label: 'Письмо' },
];
// Системные теги контакта (свободные теги тоже допустимы).
export const CRM_SYSTEM_TAGS = ['vip', 'repeat', 'agent', 'corporate', 'blacklist'];
export const CRM_MONEY_FULL_ROLES = ['owner', 'director', 'booking_manager'];
// Авто-задачи по броням TravelLine (services/crm/task-rules.js). Срок — 10:00 МСК
// дня «якорь + offsetDays»; создаются, когда срок попадает в [сегодня−1; сегодня+3].
export const CRM_TASK_RULES = [
  { key: 'pre_arrival_3d',   anchor: 'check_in',  offsetDays: -3, title: 'Связаться с гостем до заезда: время прибытия, пожелания' },
  { key: 'arrival_today',    anchor: 'check_in',  offsetDays: 0,  title: 'Заезд сегодня: подготовить номер, встретить гостя' },
  { key: 'upsell_offer',     anchor: 'check_in',  offsetDays: 1,  title: 'Предложить доп. услуги (завтрак, поздний выезд, трансфер)', minNights: 2 },
  { key: 'post_stay_review', anchor: 'check_out', offsetDays: 1,  title: 'После выезда: поблагодарить и попросить отзыв' },
];
export const CRM_CHANNEL_LABELS = Object.fromEntries(CRM_CHANNELS.map(c => [c.value, c.label]));
export const CRM_LOST_REASON_LABELS = Object.fromEntries(CRM_LOST_REASONS.map(c => [c.value, c.label]));
export const CRM_ACTIVITY_TYPE_LABELS = { ...Object.fromEntries(CRM_ACTIVITY_TYPES.map(c => [c.value, c.label])), stage_change: 'Этап', task: 'Задача', system: 'Система' };
